import React from 'react';
import './../../../pages/Profissional_Saude/Login_M/style.css';
//import axios from 'axios';
import {login} from '../../../services/Auth'
import { withRouter } from 'react-router-dom';
import api from '../../../services/api';

class Forms_PSLogin extends React.Component {
    constructor() {
        super();
        this.state = {
            email: "",
            password: "",
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }
handleSubmit = evt => {
        evt.preventDefault();

        const professional = {
            email: this.state.email,
            password: this.state.password,
        };

        if (!professional.email || !professional.password) {
            this.setState({ error: "Preencha e-mail e senha para continuar!" });
            console.log('Preencha e-mail e senha para continuar!')
        } else {api.post(`/authenticate/professional`, professional)
            .then(res => {
                console.log(res);
                console.log(res.data);
                console.log(professional);
                login(res.data.token,res.data._id);
                this.props.history.push("/tela_ps_painel");
            }
            )
        }
    }
    render() {
        return (
            <form onSubmit={this.handleSubmit} id="forms-PS-Login">
                <input onChange={this.handleChange} name="email" placeholder="E-mail" id="PS-Login" />
                <input onChange={this.handleChange} name="password" type="password" placeholder="Senha" id="PS-Login" />
                <button onClick={() => this.handleSubmit} id="PS-Login">Enviar</button>
            </form>
        );
    }
}

Forms_PSLogin = withRouter(Forms_PSLogin);
export default Forms_PSLogin;